module.exports = __webpack_public_path__ + "html/table.template.html";